module.exports = __webpack_public_path__ + "img/40_82.e29580c6.png";